




























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
// @ts-ignore
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/zh-cn';
import moment from 'moment';
@Component({ components: { DatePicker } })
export default class CustomDatePicker extends Vue {
  @Prop({ required: true }) private value!: string;
  @Prop({ type: String, default: 'date' }) dateType!: string;
  @Prop({ type: String, default: 'YYYY-MM-DD' }) dateFormat!: string;
  // 是否需要二次确认
  @Prop({ type: Boolean, default: false }) needConfirm!: boolean;
  @Prop({ type: Boolean, default: false }) dateDisable!: boolean;
  time: any = null;
  open = false;

  created() {
    this.time = this.value;
  }

  @Watch('value')
  updateLocalValue() {
    this.time = this.value;
  }

  @Watch('time')
  emitTextChange() {
    if (this.needConfirm) {
    } else {
      this.$emit('input', this.time);
      this.open = false;
    }
  }

  clearSelectedDate() {
    this.time = null;
  }

  confirmSelectedDate() {
    this.$emit('input', this.time);
    this.$emit('confirmSelectedDate', this.time);
    this.open = false;
  }

  dontNeedConfirm() {
    if (!this.needConfirm) {
      this.$emit('confirmSelectedDate', this.time);
    }
  }

  formatDate(time: string) {
    return moment(new Date(time)).format('YYYY-MM-DD');
  }
}
